module.exports = __webpack_public_path__ + "img/info-04.e8179a55.jpg";